export default {
  getHead: () => {
    return [{name: '대상 사업장명'}, {name: '피평가자'}, {name: '평가일'}, {name: '소속명'}, {name: '팀명'}, {name: '작성자'}]
  },
  getCol: (index, value, func) => {
    try {
      switch (index) {
      case 0: return func.getContent(value).companyName // 대상 사업장명
      case 1: return func.getContent(value).inputB_4 // 피평가자
      case 2: return func.getContent(value).inputB_5 // 평가일
      case 3: return func.getContent(value).stdInfo.department // 소속명
      case 4: return func.getContent(value).stdInfo.section // 부서명
      case 5: return func.getContent(value).stdInfo.writer_name // 작성자
      }
    } catch (e) { /*ignore*/ }
    return ''
  },
  getSearchKeyValue: (nav) => {
    if (nav.value.inputB_5) {
      nav.dateTarget = 'content$body.inputB_5'
      nav.dateBegin = 'nav.value.inputB_5.sDate'
      nav.dateEnd = 'nav.value.inputB_5.eDate'
    }
    return { searchType: nav.value.searchType, searchKeyword: nav.value.searchKeyword }
  },
  getSearchKeyword: (nav) => {
    const returnData = []

    switch (nav.value.searchType) {
    case '작성자': returnData.push('content$body.stdInfo.writer_name*%[:default_skw]%'); break
    case '대상사업장명': returnData.push('content$body.companyName*%[:default_skw]%'); break
    case '소속명': returnData.push('content$body.stdInfo.department*%[:default_skw]%'); break
    case '부서명': returnData.push('content$body.stdInfo.section*%[:default_skw]%'); break
    case '피평가자': returnData.push('content$body.inputB_4*%[:default_skw]%'); break
    case '평가일': returnData.push('content$body.inputB_5*%[:default_skw]%'); break
    }

    return returnData
  },
}
